<svg:g
  h3InteractiveBorderLine
  *ngFor="let line of lines$ | async; index as i; trackBy: trackByIndex"
  [p1]="line.p1"
  [p2]="line.p2"
  [lineIndex]="i"
  [shapeStore]="shapeStore"
/>
